import { Badge, Label, Switch } from '@@/ui/primitives';

interface BooleanInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
}

export function BooleanInput({ value, onChange, disabled = false, label }: BooleanInputProps) {
  return (
    <div className='flex items-center justify-between gap-4'>
      <div className='flex items-center gap-2'>
        {label && <Label className='text-neutral-900 text-sm font-medium'>{label}</Label>}
        <Badge variant='outline' className='text-slate-800 border-slate-400 text-xs!'>
          Boolean
        </Badge>
      </div>
      <Switch checked={value} onCheckedChange={(checked) => onChange(!!checked)} disabled={disabled} />
    </div>
  );
}
